export default "__VITE_ASSET__BU$FyA6N__"